import React from 'react';
import { SupportMessageBubble } from './SupportMessageBubble';

export function SupportMessageThread({
  messages,
  ticketRef,
  ticket,
  theme = 'b2c',
  threadRef,
  onThreadScroll,
  newCount,
  onScrollToBottom,
  maxHeightClass = 'max-h-[520px]',
}) {
  return (
    <div className="relative">
      {newCount > 0 && (
        <button
          type="button"
          onClick={onScrollToBottom}
          className={`absolute bottom-3 left-1/2 -translate-x-1/2 z-10 px-3 py-1.5 rounded-full text-white text-xs font-medium shadow-lg ${
            theme === 'agent' ? 'bg-teal-600 hover:bg-teal-700' : 'bg-blue-600 hover:bg-blue-700'
          }`}
          data-testid="new-messages-chip"
        >
          {newCount} new message{newCount > 1 ? 's' : ''} ↓
        </button>
      )}
      <div
        ref={threadRef}
        onScroll={onThreadScroll}
        className={`p-4 space-y-4 overflow-y-auto ${maxHeightClass}`}
        data-testid="support-message-thread"
      >
        {(messages || []).map((m) => (
          <SupportMessageBubble
            key={m.id}
            msg={m}
            ticketRef={ticketRef}
            ticket={ticket}
            theme={theme}
          />
        ))}
      </div>
    </div>
  );
}

export default SupportMessageThread;
